export default (items) => {
  const shiftedItems = [...items];
  const last = shiftedItems.pop();
  shiftedItems.unshift(last);

  return shiftedItems;
};
